import React from "react";

const TableActions = ({ children }) => {
  return (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit bg-white">
      {children}
    </div>
  );
};

export default TableActions;
